module.exports = "h2 {\n  display: block;\n  margin: 7px auto;\n  width: 348px;\n  color: white;\n  text-align: center;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/user-confirmation/user-confirmation.component.css
// module id = ./src/app/user-confirmation/user-confirmation.component.css
// module chunks = main